<template>
    <div class="card">
      <div class="card-body">
          <div class="row">
              <div class="col-md-7 col-xxl-7 d-flex flex-column justify-content-between">
                  <div class="pre-card-title">Getting paid just got simpler with the Taxi driver prepaid card</div>
                  <div class="row">
                      <div class="col-md-6">
                          <div class="pre-card-desc-text">Apply for your prepaid Mastercard today and take control of your money, your way.</div>
                      </div>
                      <div class="col-md-6">
                          <div class="pre-card-desc-text">Already received your card?</div>
                      </div>
                      <div class="col-md-6 mt-3">
                          <button class="btn btn-green" @click="$emit('apply')">Apply for a new card</button>
                      </div>
                      <div class="col-md-6 mt-3">
                          <button class="btn btn-outline-green" @click="$emit('activate')">Activate a new card</button>
                      </div>
                  </div>
              </div>
              <div class="col-md-5 col-xxl-5">
                  <img src="@/assets/images/driver/big-card.png" alt="big card" class="big-card-img" />
              </div>
          </div>
      </div>
    </div>
  </template>
  
  <style scoped>
  
  .pre-card-title {
      margin: 0;
      width: 600px;
      height: 92px;
  
      /* Portal/Portal – H2 regular */
      font-family: 'Euclid Square';
      font-style: normal;
      font-weight: 400;
      font-size: 36px;
      line-height: 46px;
      display: flex;
      align-items: center;
  
      /* Navy */
      color: #051C2C;
  }
  
  .pre-card-desc-text {
      font-family: 'Mulish';
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 23px;
      display: flex;
      align-items: center;
  
      color: #051C2C;
  }
  
  .btn {
    border-radius: 24px;
    padding: 10px 32px;
    font-size: 1rem;
    font-weight: 500;
    border: none;
    cursor: pointer;
      
  }
  .btn-green {
    background: #00c962;
    color: #051C2C;
    padding: 10px 32px;
    gap: 10px;
    width: 240px;
    height: 46px;
    border-radius: 30px;
  }
  .btn-outline-green {
    background: #fff;
    color: #051C2C;
    border: 2px solid #00c962;
    width: 240px;
    height: 46px;
  }
  
  /* .btn-green:hover {
    background: #fff;
    border: 2px solid #00c962;
  }
  
  .btn-outline-green:hover {
    background: #00c962;
  } */
  
  .big-card-img {
    max-width: 700px;
    width: 100%;
    height: auto;
  }
  </style>